var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDiscussion(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.361,
    height: 24.252,
    viewBox: "0 0 26.361 24.252",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "interface_1_",
    "data-name": "interface (1)",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4271",
    "data-name": "Path 4271",
    d: "M22.737-1.332H3.625A3.628,3.628,0,0,0,0,2.292v11.7a3.628,3.628,0,0,0,3.611,3.624V22.92l7.628-5.308h11.5a3.628,3.628,0,0,0,3.624-3.624V2.292a3.628,3.628,0,0,0-3.624-3.624Zm2.08,15.321a2.082,2.082,0,0,1-2.08,2.08H10.755l-5.6,3.9v-3.9H3.625a2.082,2.082,0,0,1-2.08-2.08V2.292A2.082,2.082,0,0,1,3.625.213H22.737a2.082,2.082,0,0,1,2.08,2.08Zm0,0",
    transform: "translate(-0.001 1.332)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4272",
    "data-name": "Path 4272",
    d: "M171.293,131.172h12.25v1.545h-12.25Zm0,0",
    transform: "translate(-164.238 -125.714)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4273",
    "data-name": "Path 4273",
    d: "M171.293,211.172h12.25v1.545h-12.25Zm0,0",
    transform: "translate(-164.238 -202.419)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4274",
    "data-name": "Path 4274",
    d: "M171.293,291.172h12.25v1.545h-12.25Zm0,0",
    transform: "translate(-164.238 -279.124)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscussion);
export default __webpack_public_path__ + "static/media/Discussion.c615bf6985bae724074e140fe57835af.svg";
export { ForwardRef as ReactComponent };